import React from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DechargeArgentForm from '../components/DechargeArgentForm';

const CreateDechargePage = () => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    navigate('/decharge-argents');
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Créer une nouvelle décharge
      </Typography>
      
      <DechargeArgentForm open={true} onClose={handleClose} />
    </Container>
  );
};

export default CreateDechargePage;
